import React, { useEffect, useState } from 'react';
import AppleSignin from 'react-apple-signin-auth';
import AppleIcon from '../images/AppleLogo.svg';
import MenuBar from '../components/Menubar';
import LoginPage from './LoginPage';
import {
	Redirect
} from "react-router-dom";

const appleClientId: string = process.env.REACT_APP_APPLE_CLIENT_ID || 'com.yolo.meal';
const appleRedirectURL: string =
  process.env.REACT_APP_APPLE_REDIRECT_URL || 'https://3c46-119-155-28-245.ngrok-free.app';

type Props = {
  user: any;
  showHome: boolean;
  showBack: boolean;
  handleLogin(user: any): void;
  handleBack(): void;
  backgroundImage: boolean;
};

const defaultProps: Props = {
  user: null,
  showHome: true,
  showBack: false,
  handleLogin: () => {},
  handleBack: () => {},
  backgroundImage: true,
};
const authOptions = {
  clientId: appleClientId,
  scope: 'name email',
  redirectURI: appleRedirectURL,
  state: 'state',
  nonce: 'nonce',
  usePopup: true,
};

const UserSignupPage: React.FC<Props> = (props) => {
  const [error, setError] = useState('');
  const [isErrorCleared, setIsErrorCleared] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [appleInfo, setappleInfo] = useState(false);
  const [appleSignIn, setappleSignIn] = useState(true);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showFormError, setShowFormError] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  useEffect(() => {
    if (showFormError) {
      const timer = setTimeout(() => {
        setShowFormError(false);
      }, 2000); // Hide after 3 seconds

      return () => clearTimeout(timer);
    }
  }, [showFormError]);

  const renderAppleAuthButton = (props: JSX.IntrinsicAttributes & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button {...props}>
      <img
        src={AppleIcon}
        alt="Apple Icon"
        style={{ marginRight: '5px', width: '24px', height: '24px', alignItems: 'center' }}
      />
      Sign in with Apple
    </button>
  );

  const getReferrer = () => {
    var path = window.location.href;
    const arr = path.split('?');
    if (arr.length === 2) {
      const params = arr[1];
      const paramsArr = params.split('=');
      if (paramsArr.length === 2 && paramsArr[0] === 'referrer') {
        return paramsArr[1];
      }
    }
    return '';
  };

  const handleJoinClick = () => {

    const isFormValid =
      name.trim() !== '' &&
      email.trim() !== '' &&
      password.trim() !== '' &&
      confirmPassword.trim() !== '' &&
      password === confirmPassword;

    if (!isFormValid) {
      setShowFormError(true);
      return;
    }

    console.log('request gone');
    let data = {
      userName: name,
      email: email,
      password: password,
      referer: getReferrer(),
    };

    console.log('Sending data to backend:', data);

    fetch(process.env.REACT_APP_SERVER_URL + '/register', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
      body: JSON.stringify(data),
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.json())))
      .then(
        (result) => {
          setIsErrorCleared(true);
          console.log('after successful login ===> ', result);
          props.handleLogin(result);
          let obj = {
            facebookLogin: false,
            appleLogin: false,
            simpleLogin: true,
          };
          localStorage.setItem('loginInfo', JSON.stringify(obj));
          setIsRegister(true);
        },
        (error) => {
          error.then((body) => {
            setError(body.message);
            setIsErrorCleared(false);
            setIsRegister(false);
          });
        }
      );
  };

  const handleAppleResponse = (response) => {
    const authorizationInfo = response.authorization;

    let userInfo = response?.user;

    let data = {};

    if (authorizationInfo) {
      if (userInfo) {
        data = { authorization: authorizationInfo, user: userInfo, referrer: 6 };
      } else {
        data = { authorization: authorizationInfo, referrer: 6 };
      }


      fetch(process.env.REACT_APP_SERVER_URL + '/login', {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('after successful login ===> ', result);
            props.handleLogin(result);
            let obj = {
              facebookLogin: false,
              appleLogin: true,
              simpleLogin: false,
            };
            localStorage.setItem('loginInfo', JSON.stringify(obj));
          },
          (error) => {
            setError(error.message);
            console.log(error);
          }
        );
    } else {
      var error = 'Apple Login error';
      if (response.hasOwnProperty('status')) {
        error = response.status;
      }
      setError(error);
    }
  };

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setIsErrorCleared(true);
  };

  if (isRegister) {
    const redirectPath = localStorage.getItem("redirectAfterLogin");
    localStorage.removeItem("redirectAfterLogin");

    if (redirectPath) {
      window.location.replace(redirectPath);
      return null;
    }

    window.location.replace("/home");
    return null;
  }

  return (
    <main className="main-bg">
      <div className="container">
        <MenuBar user={props.user} />
      </div>
      <div className="small-container">
        <div className="startpage-content">
          <div
            className="start-row d-flex full-height align-items-center"
            style={{ flexDirection: 'column', paddingTop: '0px' }}
          >
            <div className="about-content terms-content faq-content mb-4 pb-4 f-15">
              <div className="terms-box bg-white singup-msg">
                <p>
                  Welcome! Yolomeal is the place to save your favorite food finds from local restaurants and to
                  instantly find the best tasting food in your city.
                </p>
              </div>
            </div>

            {error !== '' && isErrorCleared == false && (
              <p style={{
                color: '#ffffff',
                fontSize: '14px',
                marginBottom: '20px',
                textAlign: 'center',
                fontFamily: 'sans-serif',
                backgroundColor: '#FFABAB',
                padding: '10px',
                borderRadius: '5px',
                width: 'fit-content',
                margin: '0 auto'
              }}>
                {error}
              </p>
            )}

            <input
              id="user-name"
              className="field md-filed text-center"
              placeholder="Enter Your Desired Display Username"
              value={isErrorCleared ? name : error ? '' : name}
              onChange={handleInputChange(setName)}
              style={{
                boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
              }}
            />
            <input
              id="user-email"
              className="field md-filed text-center"
              placeholder="Enter Your Email"
              onChange={(e) => setEmail(e.target.value)}
              style={{
                boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
              }}
            />

            <input
              id="user-password"
              className="field md-filed text-center"
              placeholder="Enter Your Password"
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
              }}
            />

            <input
              id="confirm-password"
              className="field md-filed text-center"
              placeholder="Confirm Password"
              type="text"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={{
                boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px'
              }}
            />

            {password !== confirmPassword && confirmPassword !== '' && (
              <p style={{ color: 'red', fontSize: '14px' }}>Passwords do not match</p>
            )}

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '20px',
                gap: '15px',
              }}
            >
              <input type="button"
                     className="btn-primary"
                     value="New Members - Join"
                     onClick={handleJoinClick}
                     disabled={isRegister}
                     style={{
                       backgroundColor: isRegister ? '#ccc' : '',
                       color: isRegister ? '#666' : '',
                       transition: 'all 0.3s ease'
                     }}
              />
              <h3 style={{ color: 'black', margin: '0px 0 0px 0' }}>OR</h3>

              <div className="apple-auth-div" style={{ marginTop: '0px' }}>
                {(appleInfo == false || appleSignIn) && (
                  <AppleSignin
                    authOptions={authOptions}
                    uiType="dark"
                    className="apple-auth-btn"
                    buttonExtraChildren="Sign in with Apple"
                    onSuccess={(response: any) => handleAppleResponse(response)}
                    onError={(error: any) => console.error(error)}
                    skipScript={false}
                    render={renderAppleAuthButton}
                  />
                )}
              </div>

              {showFormError && (
                <div
                  style={{
                    position: 'fixed',
                    top: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#ffdddd',
                    color: '#b10000',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    fontSize: '16px',
                    zIndex: 9999,
                    animation: 'floatUp 0.3s ease-out',
                  }}
                >
                  Please fill in all fields and ensure passwords match.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

LoginPage.defaultProps = defaultProps;

export default UserSignupPage;
